import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { DashboardApi } from '../../../services'
import { IAmericanState } from '../../../types'
import { AmericanStatesInitialState } from '../americanStates.slice'

export const fetchAmericanStatesAsync = createAsyncThunk(
  'states/fetchStates',
  async (_, { rejectWithValue }) => {
    try {
      const user = await DashboardApi.fetchAmericanStates();
      return (user as AxiosResponse<any, any>).data
    } catch (error: any) {
      console.error(error)
      return rejectWithValue({
        message: error.message || 'An unknown error occurred',
      });
    }
  }
);

export const fetchAmericanStatesAsyncBuilder = (
  builder: ActionReducerMapBuilder<AmericanStatesInitialState>,
) => {
  builder.addCase(fetchAmericanStatesAsync.pending, (state, action) => {
    state.loading = true
    state.success = false
    state.error = ''
  })
  builder.addCase(
    fetchAmericanStatesAsync.fulfilled,
    (state, action: PayloadAction<IAmericanState[]>) => {
      state.loading = false
      state.success = true
      state.data.states = action.payload
    },
  )
  builder.addCase(fetchAmericanStatesAsync.rejected, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = false
    state.error = action.payload
  })
}
